import { PromoAdInput, useMediaAdCampaignPromosUpdateMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { serializePromoAdInputs } from '../lib/serializePromoAdInputs';

import { UsePromoUploadResultType } from './usePromoUpload';

export type UseAdCampaignPromoUploadType = [
  request: (adCompanyId: string, adPromos: PromoAdInput[]) => Promise<boolean>,
  result: UsePromoUploadResultType,
];

const useAdPromosUpdate = (): UseAdCampaignPromoUploadType => {
  const [createMutation, createMutationResult] = useMediaAdCampaignPromosUpdateMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (adCompanyId: string, adPromos: PromoAdInput[]) => {
    const newAdCampaign = await createMutation({
      variables: {
        input: {
          adCompanyId,
          adPromos: serializePromoAdInputs(adPromos),
        },
      },
      onQueryUpdated(observableQuery) {
        return observableQuery.refetch();
      },
    });

    return !!newAdCampaign.data?.result?.ok;
  };

  const result: UsePromoUploadResultType = {
    error: createMutationResult.error,
    loading: createMutationResult.loading,
    called: createMutationResult.called,
  };

  return [request, result];
};

export default useAdPromosUpdate;
